import { v4 as r } from "uuid";
var o = {}, a = () => r(), t = () => r();
export {
  a as generateCorrelationId,
  t as generateSessionId,
  o as inMemoryStore
};

//# sourceMappingURL=useBffApi.helpers.js.map